<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <!-- <v-card class="box" v-if="ay_std_div_list != null"> -->
            <!-- <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Import Remark </strong>
                </v-toolbar-title>
            </v-toolbar> -->
            <br>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined @change="getStd()"
                        hint="Please select academic year" persistent-hint />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list"
                        item-text="display_name" item-value="id" label="Semester" hint="Please select semester"
                        persistent-hint />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                        :items="std_div_list" item-text="std" label="Standard" persistent-hint outlined
                        @change="getDiv();" hint="Please select standard" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list"
                        item-text="div_name" label="Division" outlined hint="Please select division" persistent-hint />
                </v-col>
                <v-col cols="12" sm="1" md="1" v-if="sel_ay_data && sel_std_data && div">
                    <v-btn class="mt-6 button" @click="getLearnerRemarks()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <br><br><br>
            <div v-if="maxWordLimit != null" class="text-caption mb-2" style="color: #555;">
                Note: Maximum {{ maxWordLimit }} words are allowed for remark.
            </div>
            <v-data-table v-if="remark_data.length > 0" fixed-header height="500" :headers="headers"
                :items="remark_data" disable-pagination hide-default-footer dense class="remark-table">

                <template v-slot:item.sr_no="{ item }">
                    <span class="font-weight-medium">{{ item.sr_no }}</span>
                </template>

                <template v-slot:item.special_achievement="{ item }">
                    <v-textarea v-model="item.special_achievement" @keydown="e => preventExtraWords(e, item.special_achievement)" @paste="e => handlePaste(e, item.special_achievement)" rows="2" auto-grow outlined dense hide-details class="py-4"
                        placeholder="Enter progress..."></v-textarea>
                </template>

                <template v-slot:item.extra_carricular_activities="{ item }">
                    <v-textarea v-model="item.extra_carricular_activities" @keydown="e => preventExtraWords(e, item.extra_carricular_activities)" @paste="e => handlePaste(e, item.extra_carricular_activities)" rows="2" auto-grow outlined dense
                        hide-details placeholder="Enter hobbies..."></v-textarea>
                </template>

                <template v-slot:item.remark="{ item }">
                    <v-textarea v-model="item.remark" @keydown="e => preventExtraWords(e, item.remark)" @paste="e => handlePaste(e, item.remark)" rows="2" auto-grow outlined dense hide-details
                        placeholder="Expected improvement..."></v-textarea>
                </template>

            </v-data-table>
            <hr v-if="remark_data.length > 0">
            <v-row v-if="remark_data.length > 0" justify="center" class="my-2">
                <v-btn color="success" @click="saveRemarks">
                    Save All
                </v-btn>
            </v-row>

        <!-- </v-card> -->
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data() {
        return {
            snackbar: false,
            overlay: false,
            search: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            ay_std_div_list: null,
            sel_ay_data: null,
            std_div_list: null,
            sel_std_data: null,
            div_list: null,
            div: null,
            sem: null,
            fetch_loader: false,
            standard: null,
            division: null,
            org_basic_data: [],
            role: null,
            type: null,
            semester_list: [],
            remark_data: [],
            headers: [
                { text: "Sr. No.", value: "sr_no" },
                { text: "Roll No.", value: "roll_no" },
                { text: "Registration No.", value: "prn" },
                { text: "Student Name", value: "student_name" },
                { text: "Remarkable Progress", value: "special_achievement" },
                { text: "Hobbies", value: "extra_carricular_activities" },
                { text: "Expected Improvement", value: "remark" }
            ],
            maxWordLimit: null,
        };
    },

    methods: {


        preventExtraWords(e, value) {
            if (!value) return
            if (!this.maxWordLimit) return

            const words = value.trim().split(/\s+/).filter(w => w)

            const allowedKeys = [
                "Backspace", "Delete", "ArrowLeft", "ArrowRight",
                "ArrowUp", "ArrowDown", "Tab"
            ]

            if (allowedKeys.includes(e.key)) return

            if (words.length >= this.maxWordLimit && e.key === " ") {
                e.preventDefault()
            }
        },

        handlePaste(e, value) {
            if (!this.maxWordLimit) return
            const pasted = (e.clipboardData || window.clipboardData).getData('text')
            const totalWords = (value + " " + pasted).trim().split(/\s+/).length

            if (totalWords > this.maxWordLimit) {
                e.preventDefault()
            }
        },
        
        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text = tab_text + "<table border='1px'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

            //Save the file
            // var blob = new Blob([tab_text], {
            //   type: "application/vnd.ms-excel;charset=utf-8",
            // });
            // window.saveAs(blob, fileName);
            const blob = new Blob([tab_text], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            const filename = name + ".xls";

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        getStd() {
            this.std_div_list = null;
            this.sel_std_data = null;
            this.div_list = null;
            this.div = null;
            this.std_div_list = this.sel_ay_data.std_list;
        },
        getDiv() {
            this.div_list = this.sel_std_data.div_list;
            this.div = this.div_list[0];
            if (this.div_list.length == 0) {
                alert("No division found!!!");
                this.div_list = null;
            }
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onload() {
            this.overlay = true;
            axios
                .post("/commonAPI/get_ay_std_div_by_access")
                .then((res) => {
                    this.ay_std_div_list = res.data.data;
                    this.semester_list = res.data.sem_list
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        getLearnerRemarks() {
            // if (!this.sel_ay_data || !this.sem || !this.asd || !this.sel_std_data || !this.div) {
            //     this.showSnackbar("error", "Please select all required fields!");
            //     return;
            // }
            this.remark_data = []
            const data = {
                ay: this.sel_ay_data.ay_id,
                standard: this.sel_std_data.std_id,
                div: this.div.div_off_id,
                sem: this.sem,
            };
            this.fetch_loader = true;
            axios
                .post("/Examination/getLearnerRemarks", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.remark_data = res.data.remark_data;
                        this.maxWordLimit = res.data.maxWordLimit;
                    }
                    else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        this.fetch_loader = false
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    this.fetch_loader = false
                })
                .finally(() => {
                    this.fetch_loader = false
                });
        },
        saveRemarks() {

            const payload = {
                ay: this.sel_ay_data.ay_id,
                sem: this.sem,
                standard: this.sel_std_data.std_id,
                div: this.div.div_off_id,
                students: this.remark_data
            }

            this.overlay = true

            axios.post("/Examination/saveLearnerRemarks", payload)
                .then((res) => {

                    if (res.data.flag == "YES") {
                        this.showSnackbar("success", "Remarks saved successfully")
                    } else {
                        this.showSnackbar("#b71c1c", "Failed to save remarks")
                    }

                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong...")
                })
                .finally(() => {
                    this.overlay = false
                })
        }
    },
    mounted() {
        this.role = localStorage.getItem("para_role");
        this.onload();
    },
};
</script>
<style scoped>   
.remark-table >>> thead th {
    background-color: #7b7b7b !important;
    color: white !important;
    font-weight: 600;
    font-size: 14px;
    padding: 10px;
    text-align: center !important;
}
.remark-table >>> td{
    text-align: center !important;
}
</style>
